<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";
    import {ClipboardUtil} from "../../../lib/Common/Form/ClipboardUtil";
    import {MouseEnterTipsViewUtil} from "../Information/MouseEnterTipsViewUtil";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";
    import {MessageStore} from "../../../store/MessageStore";

    export let text;
    export let url = null;
    export let copySuccessMessage = "コピーされました";
    export let label = null;
    export let fontAwesomeIcon = 'link';
    export let fontAwesomeClassification = null;

    onMount(() => {
    });

    function onClick(event) {
        if (ValueUtil.isEmpty(text)) {
            MessageStore.showConfirmInformation("コピーするテキストがありません");
            return;
        }

        if (url != null) {
            ClipboardUtil.copyLink(text, url);

        } else {
            ClipboardUtil.copy(text);

        }

        MouseEnterTipsViewUtil.show(event, copySuccessMessage);
    }

</script>

<span class="copy-text-button-view" on:click={onClick} class:border={label != null}>
    <FontAwesomeView icon={fontAwesomeIcon} classification={fontAwesomeClassification}/>
    {#if label != null}
        { label }
    {/if}
</span>

<style lang="scss">
    .copy-text-button-view {
        cursor: pointer;
        display: inline-block;
        white-space: nowrap;

        &.border {
            border-style: solid;
            border-width: 1px;
            border-color: #0003;
            border-radius: 0.25em;

            padding-left: 0.5em;
            padding-right: 0.5em;
        }

    }
</style>